import * as React from 'react';
import { SVGProps } from 'react';

const IconMGRPSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.056 9 12.61 5.828l.698-2.759L11.39 1 12 3.069 9.556 5.828 9.86 9H1v2h22V9h-7.944zm-6.112 6 2.445 3.172-.698 2.759L12.61 23 12 20.931l2.444-2.759L14.14 15H23v-2H1v2h7.944z" />
  </svg>
);
export default IconMGRPSizeM;
